import ImportDocumentsModalView from "./ImportDocumentsModal.html";


angular.module("import_documents")

    .controller("ImportDocumentsListCtrl", ['LoginService', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$stateParams', '$state', 'logService',
        function (LoginService, $rootScope, $scope, Restangular, gridService, modalService, $uibModal, $filter, $translate, $stateParams, $state, logService) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("IMPORT_DOCUMENT_WRITE");

            $rootScope.title = $filter('translate')('import_documents.title');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('import_documents.title') }
            ];

            $scope.gridOptionsImportDocument = {
                pdfTitle: $filter('translate')('import_documents.title'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                gridMenuShowHideColumns: false,
                enableSorting: true,
                paginationPageSizes: [20, 40, 60],
                paginationPageSize: 20,
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                  { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                  { name: 'name', displayName: $filter('translate')('import_documents.name'), enableFiltering: true, enableHiding: false },
                  {
                      name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                          //{ title: $filter('translate')('import_documents.button_download'), action: 'ng-click="grid.appScope.download(row.entity);"', cssIconClass: "fa fa-download" },
                          { title: $filter('translate')('import_documents.button_upload'), action: 'ng-click="grid.appScope.openModal(row.entity);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-upload" }
                      ], { cssClass: "pull-right" })
                  }

                ],
                getData: function (options) {
                    return Restangular.all('ImportDocuments').getList(options);
                }
            };

            $scope.download = function (file) {
                logService.debug("Eliminado, el documento correcto lo tiene Rodolfo. Si se quiere, revisar el documento en App_Data/import_formats");
                window.open((window as any).CONFIG.api_url + 'ImportDocuments/getFile?id=' + file.id, '_blank', '');
            }

            $scope.openModal = function (file) {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: ImportDocumentsModalView,
                    size: "md",
                    controller: "ImportDocumentsModalCtrl",
                    resolve: {
                        options: function () {
                            return { file: file };
                        }
                    }
                });
                //Response del modal
                $modalInstance.result.then(function (data) {
                }, function () {
                });
            }
        }
    ])

    .controller("ImportDocumentsModalCtrl", ['LoginService','options', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$uibModalInstance', '$filter', '$translate', '$stateParams', '$state', 'Upload', 'logService',
        function (LoginService, options, $rootScope, $scope, Restangular, gridService, modalService, $uibModalInstance, $filter, $translate, $stateParams, $state, Upload, logService) {

            $scope.import_documents = options.file;
            if ($scope.import_documents.file_name != null)
                $scope.import_documents.file_name = "";

            logService.debug("options: ")
            logService.debug(options);

            logService.debug("$scope.import_documents: ")
            logService.debug($scope.import_documents)

            $scope.file = {};

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("IMPORT_DOCUMENT_WRITE");

            $scope.uploadFiles = function ($file) {
                $scope.errorMsg = undefined;
                $scope.file = $file;
                $scope.import_documents.file_name = $scope.file.name;
            }

            var uploadToServer = function () {
                $scope.file.upload = Upload.upload({
                    url: (window as any).CONFIG.api_url + "ImportDocuments/" + $scope.import_documents.method,
                    data: { file: $scope.file, name: $scope.import_documents.file_name, insert: false },
                });
                $scope.file.upload.then(function (response) {
                    if (response.data) {
                        logService.debug(response.data, response);
                        $scope.errorMsg = response.data;
                        $scope.isValidated = $scope.errorMsg.length == 0;
                    } else {
                        $scope.import_documents.file_name = undefined;
                        $uibModalInstance.close();
                    }
                }, function (response) { //error
                    $scope.errorMsg = response.data;
                });
            }

            var insertToDataBase = function () {
                $scope.file.upload = Upload.upload({
                    url: (window as any).CONFIG.api_url + "ImportDocuments/" + $scope.import_documents.method, // + $scope.import_documents.method,
                    data: { file: $scope.file, name: $scope.import_documents.file_name, insert: true },
                });

                $scope.file.upload.then(function (response) {
                    if (response.data) {
                        $scope.errorMsg = response.data;
                    } else {
                        toastr.success($filter('translate')('import_documents.upload_success'));
                        $scope.import_documents.file_name = undefined;
                        $uibModalInstance.close();
                        if ($scope.import_documents.method == 'importFilePersonsGroups') {
                            $state.go("persons.list", { person_type: 'imported' }); // A petición de Rodolfo, después de importar personas vamos directamente al l
                        }
                    }
                }, function (response) { //error
                    $scope.errorMsg = response.data;
                });
            }

            //Validación del fichero seleccionado
            $scope.onAccept = function () {
                if ($scope.import_documents.file_name != "" && $scope.import_documents.file_name != "undefined" && $scope.import_documents.file_name != null) {
                    uploadToServer();
                }
            };

            //Importar los datos del fichero seleccionado
            $scope.onImport = function () {
                if ($scope.import_documents.file_name != "" && $scope.import_documents.file_name != "undefined" && $scope.import_documents.file_name != null) {
                    insertToDataBase();
                }
            };

            $scope.onCancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }
    ])
;